<div class="wrapper">
  <div class="sidebar" data-color="white" data-background-color="white" data-image="assets/img/sidebar-1.jpg">
    <app-sidebar-cmp></app-sidebar-cmp>
    <!--div class="sidebar-background" style="background-image: url(assets/img/sidebar-1.jpg)"></div-->
  </div>
  <div class="main-panel">
    <router-outlet></router-outlet>
  </div>
</div>
